import React, { PropsWithChildren } from 'react';

import Icon, { IconProp, SizeProp } from '~components/icon';

interface ComponentProps extends PropsWithChildren {
  className?: string;
  icon?: IconProp;
  iconSize?: SizeProp;
  dataCy?: string;
  actionButtons?: React.ReactNode[];
  settingsElement?: React.ReactNode;
}

const ContainerHeader: React.FC<ComponentProps> = ({
  className,
  icon,
  iconSize = '1x',
  children,
  dataCy = '',
  actionButtons,
  settingsElement,
}) => {
  return (
    <div
      className={`d-flex flex-row justify-content-between ps-3 pe-3 header${className !== undefined ? ` ${className}` : ''}`}
    >
      <div className="d-flex flex-row align-items-center">
        {icon && <Icon size={iconSize} icon={icon} className="me-2" />}
        <h3 data-cy={dataCy} className="mb-0 d-flex align-items-center">
          {children}
          {settingsElement && (
            <span className="d-flex align-items-center justify-content-center">{settingsElement}</span>
          )}
        </h3>
      </div>
      <div className="d-flex flex-row align-items-center">
        {actionButtons &&
          actionButtons.map((action, index) => (
            <div key={index} className="d-flex align-items-center">
              {action}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ContainerHeader;
